// extracted by mini-css-extract-plugin
module.exports = {"Root":"Error_Root__3nrPN","Accordion":"Error_Accordion__YqLws","SecondButton":"Error_SecondButton__rSmzj"};